import axios from "axios";
import React, { useEffect, useContext } from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../src/WebPages/Home.css";
import ReactGA from "react-ga4";
import UserContext from "./context/UserContext";
import common_axios from "./Services/commonAxios";
import { useRef } from "react";

function Splash() {
  const { update, updateCartCount } = useContext(UserContext);
  const nav = useNavigate();
  let { session_token } = useParams();
  const [progress, setProgress] = useState(0);
  const check = "Y";
  const [isFaug, setIsFaug] = useState("N");
  const clearedRef = useRef(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await common_axios.get(
          `/store_user/credential?session_token=${session_token}`
        );
        const token = resp.data.data;
        setIsFaug(resp.data.isFaug);

        // Prevent infinite loop by tracking localStorage clear
        if (resp.data.shouldClearLocalStorage === "Y") {
          localStorage.clear();
          localStorage.setItem("clearedOnce", "true");
          // console.log("LocalStorage cleared for session:", session_token);
          // Optionally call credential_clear API here
          // await common_axios.get(`/store_user/credential_clear?session_token=${session_token}`);
          await common_axios.get(
            `/store_user/credential_clear?session_token=${session_token}`
          );
        }

        if (token === "Undifined") {
          return nav("/404");
        }

        ReactGA.set({ userId: session_token });

        if (localStorage.getItem("auth")) {
          localStorage.setItem("session_token", token);
        } else {
          localStorage.setItem("token", token);
          localStorage.setItem("session_token", token);
        }

        update(token);
        updateCartCount();

        const timer = setInterval(() => {
          setProgress((oldProgress) => {
            if (oldProgress === 100) {
              clearInterval(timer);
            }
            const diff = Math.random() * 8;
            return Math.min(oldProgress + diff, 100);
          });
        }, 50);

        setTimeout(() => {
          if (isFaug === "N") {
            nav("/events", { replace: true });
          } else {
            nav("/home", { replace: true });
          }
        }, 2000);
      } catch (err) {
        console.log(err.message);
      }
    };

    fetchData();
  }, [session_token]);

  return (
    <main className="loading-main">
      <img src="/assets/images/icespice-logo.png" alt="IceSpice Logo" />
      <div className="loading-bars">
        <div className="loading-bar" style={{ width: `${progress}%` }} />
      </div>
      <div className="circleblur1" />
    </main>
  );
}

export default Splash;
